module.exports = __webpack_public_path__ + "img/al-shiddi.21d98c9e.png";